import React from 'react';
import Button from "./button";

const LoginButton = ({title, style, ...props}) => {
  return <Button title={title} {...props} style={{
    backgroundColor: '#F3ECFF',
    color: '#9738FF',
    position: 'relative',
    // marginLeft: 'auto',
    display: 'block'
  }} />
};

export default LoginButton;
